<template lang="pug">
  .your-order(v-if="data.step=='your-order'")
    .your-order__list
      .your-order__list-item.your-order__list-item--empty(:class="{'your-order__list-item--hide': data.countProductsToCart > 0}")
        .your-order__list-item-text Ваша корзина пока пуста, загляните в&nbsp;
          router-link.your-order__list-item-link(to="/menyu") наше меню

      .your-order__list-item.your-order__list-item--product(v-if="data.order && item.id!=137", v-for="item in data.order")
        a.your-order__list-item-left.your-order__list-item-img-wr-link(v-if="item.imageOriginSrc.path", :href="item.imageOriginSrc.path")
          .your-order__list-item-img-wr(v-if="item.imagePreview.path", :data-src="item.imagePreview.path")
            img.your-order__list-item-img.your-order__list-item-img--hide(:src="item.imagePreview.path")
          .your-order__list-item-desc
            .your-order__list-item-desc-name(v-if="item.name") {{item.name}}
            .your-order__list-item-desc-text(v-if="item.description") {{item.description}}
        .your-order__list-item-volumes
          .your-order__list-item-volume(v-for="volume in item.volumes", :key="volume.id" :data-id="volume.id" :class="{'your-order__list-item-volume--active': volume.id == item.activeVolumeId}" v-if="item.id !=='wish'" @click="addProductToCart($event, item.id, 'input', volume.id)") {{volume.value}} {{volume.dec}}
        .your-order__list-item-prices
          .your-order__list-item-price {{item.price.amount}} {{item.price.currency}}
          .your-order__list-item-counter
            button.your-order__list-item-counter-button.your-order__list-item-counter-button--dec(type="button" @click="addProductToCart($event, item.id, 'minus')", :class="{'your-order__list-item-counter-button--disabled': item.count < 2}")
            input.your-order__list-item-counter-input(type="number", min="1", :value="item.count", @input="addProductToCart($event, item.id, 'input')")
            button.your-order__list-item-counter-button.your-order__list-item-counter-button--inc(type="button" @click="addProductToCart($event, item.id, 'plus')")
          .your-order__list-item-full-price {{item.full_price.amount}} {{item.full_price.currency}}
        button.your-order__list-item-delete(@click="removeProductFromCart($event, item.id)")

      //.your-order__list-item.your-order__list-item--customer-desire(:class="{'your-order__list-item--hide': wishInCart || !data.countProductsToCart > 0}")
        button.your-order__customer-desire-button(@click="addProductToCart($event, '137', 'input')")
          .your-order__customer-desire-button-icon
          .your-order__customer-desire-button-text Желание гостя

      //.your-order__list-item.your-order__list-item--product.your-order__list-item--wish(:class="{'your-order__list-item--hide': !wishInCart}")
        a.your-order__list-item-left.your-order__list-item-img-wr-link(href='/img/content/wish.png')
          .your-order__list-item-img-wr
            img.your-order__list-item-img(src='/img/content/wish.png')
          .your-order__list-item-desc
            .your-order__list-item-desc-name Желание гостя
            .your-order__list-item-desc-text Аристарх свяжется с вами ;)
        .your-order__list-item-volumes
        .your-order__list-item-prices
          .your-order__list-item-price 1 p.
          .your-order__list-item-counter
            button.your-order__list-item-counter-button.your-order__list-item-counter-button--dec.your-order__list-item-counter-button--disabled(type='button', @click="addProductToCart($event, '137', 'minus')")
            input.your-order__list-item-counter-input(type="number", min="1", value="1", @input="addProductToCart($event, '137', 'input')")
            button.your-order__list-item-counter-button.your-order__list-item-counter-button--inc(type='button', @click="addProductToCart($event, '137', 'plus')")
          .your-order__list-item-full-price 1 p.
        button.your-order__list-item-delete(@click="removeProductFromCart($event, '137')")

      .your-order__list-item.your-order__list-item--order-panel(:class="{'your-order__list-item--hide': !data.countProductsToCart > 0}")
        .your-order__order-panel-content
          button.your-order__order-panel-clear(@click="removeAllProducts") Очистить корзину
          .your-order__order-panel-block
            .your-order__order-panel-block-info
              .your-order__order-panel-block-total
                .your-order__order-panel-block-text Итого:&nbsp;
                .your-order__order-panel-block-price(v-if="data.cartSummTotal.amount") {{data.cartSummTotal.amount}} {{data.cartSummTotal.currency}}
              .your-order__order-panel-block-description(v-if="data.minOrderAmount > data.cartSummTotal.amount") Минимальная сумма заказа {{data.minOrderAmount}} рублей
            router-link.your-order__order-panel-block-button(to="/korzina/adres-dostavki", :class="{'your-order__order-panel-block-button--disabled': data.minOrderAmount > data.cartSummTotal.amount}") Далее
</template>

<script>
import EventBus from '@/eventBus';

//import '@/components/yourOrder/yourOrder.styl';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {ImagePreloaderVue} from '@/mixins/ImagePreloaderVue';
import {CartHelpersVue} from '@/mixins/CartHelpersVue';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

// @ is an alias to /src
//import Events from '@/components/events/Events.vue';

export default {
  name: 'YourOrder',

  mixins: [AjaxHelpersVue, ImagePreloaderVue, CartHelpersVue],

  props: {
    data: {
      type: Object,
      required: true,
      default: null
    }
  },

  data() {
    return {
      wishInCart: false
    }
  },

  components: {
    SvgIcon
    //Events
  },

  created() {
    this.$nextTick(() => {
      this.imgPreloader('your-order__list-item-img-wr', 'your-order__list-item-img', '', 250);
      this.initFancy();
      //this.checkWish();
    });
  },

  methods: {
    addProductToCart(e, productId, type, volumeId) {
      let $input = $(e.target).parents('.your-order__list-item').find('input');
      let count = parseInt($input.val());
      let $minusBtn = $(e.target).parents('.your-order__list-item-counter').find('.your-order__list-item-counter-button--dec');
      let minusBtnClass = 'your-order__list-item-counter-button--disabled';
      let $productPrice = $(e.target).parents('.your-order__list-item').find('.your-order__list-item-price');
      let $productFullPrice = $(e.target).parents('.your-order__list-item').find('.your-order__list-item-full-price');
      let $totalSum = $('.your-order__order-panel-block-price');
      let $cartWidget = $('.cart-widget');
      let cartWidgetClass = 'cart-widget--active';
      let $cartWidgetCount = $('.cart-widget__count');
      let cartWidgetCountClass = 'cart-widget__count--hide';
      let $cartWidgetCountNum = $('.cart-widget__count-num');
      let $itemVolume = $(e.target).parents('.your-order__list-item').find('.your-order__list-item-volume');
      let itemVolumeClass = 'your-order__list-item-volume--active';

      if(productId == '137') {
        $input = $('.your-order__list-item--wish').find('input');
        this.wishInCart = true;
      }

      count = this.getAmount($input, type, 1);
      $input.val(count);

      if(count == '' || count == 0) {
        return false;
      }

      if(count < 2) {
        $minusBtn.addClass(minusBtnClass);
      } else {
        $minusBtn.removeClass(minusBtnClass);
      }

      let params = {
        cartId: this.getCartId(),
        productId: productId,
        amount: count
      };

      if(volumeId) {
        params.volumeId = volumeId;
      }

      this.addToCart((res) => {
        if(this.checkProperty(this.checkProperty(res.status) && res.status === 'ok')) {
          this.$nextTick(() => {
            $productPrice.text(res.productPrice.amount + ' ' + res.productPrice.currency);
            $productFullPrice.text(res.totalProductPrice.amount + ' ' + res.totalProductPrice.currency);
            $totalSum.text(res.cartSummTotal.amount + ' ' + res.cartSummTotal.currency);
            $cartWidgetCountNum.text(res.countProductsToCart);

            if(res.countProductsToCart > 0) {
              $cartWidget.addClass(cartWidgetClass);
              $cartWidgetCount.removeClass(cartWidgetCountClass);
            } else {
              $cartWidget.removeClass(cartWidgetClass);
              $cartWidgetCount.addClass(cartWidgetCountClass);
            }

            if(volumeId) {
              $itemVolume.removeClass(itemVolumeClass);
              $(e.target).addClass(itemVolumeClass);
            }
          });
        }
      }, params);
    },

    removeProductFromCart(e, productId) {
      let $item = $(e.target).parent();
      let $totalSum  = $('.your-order__order-panel-block-price');
      let $cartWidget = $('.cart-widget');
      let cartWidgetClass = 'cart-widget--active';
      let $cartWidgetCount = $('.cart-widget__count');
      let cartWidgetCountClass = 'cart-widget__count--hide';
      let $cartWidgetCountNum = $('.cart-widget__count-num');
      let $customerDesire = $('.your-order__list-item--customer-desire');
      let $clearBtn = $('.your-order__order-panel-clear');
      let $nextBtn = $('.your-order__order-panel-block');
      let hideClass = 'your-order__order-panel-content--hide';

      let params = {
        cartId: this.getCartId(),
        productId: productId
      };

      this.removeFromCart((res) => {
        if(this.checkProperty(this.checkProperty(res.status) && res.status === 'ok')) {
          this.$nextTick(() => {
            if(productId != '137') {
              $item.slideUp(250, function() {
                $(this).remove();

                if($('.your-order__list-item--product').not('.your-order__list-item--wish').length < 1) {
                  $cartWidget.removeClass(cartWidgetClass);
                  $cartWidgetCount.addClass(cartWidgetCountClass);
                  $clearBtn.addClass(hideClass);
                  $nextBtn.addClass(hideClass);
                  $customerDesire.slideUp(250, function() {
                    $('.your-order__list-item--empty').removeClass('your-order__list-item--hide');
                  });
                }
              });
            } else {
              this.wishInCart = false;
              $('.your-order__list-item--wish').find('input').val('1');
              $('.your-order__list-item--wish').find('.your-order__list-item-counter-button--dec').addClass('your-order__list-item-counter-button--disabled');
              $('.your-order__list-item--wish').find('.your-order__list-item-price').text('1 р.');
              $('.your-order__list-item--wish').find('.your-order__list-item-full-price').text('1 р.');
            }

            $totalSum.text(res.cartSummTotal.amount + ' ' + res.cartSummTotal.currency);
            $cartWidgetCountNum.text(res.countProductsToCart);

            if(res.countProductsToCart > 0) {
              $cartWidget.addClass(cartWidgetClass);
              $cartWidgetCount.removeClass(cartWidgetCountClass);
            } else {
              $cartWidget.removeClass(cartWidgetClass);
              $cartWidgetCount.addClass(cartWidgetCountClass);
            }
          });
        }
      }, params);
    },

    removeAllProducts() {
      let $cartWidget = $('.cart-widget');
      let cartWidgetClass = 'cart-widget--active';
      let $cartWidgetCount = $('.cart-widget__count');
      let cartWidgetCountClass = 'cart-widget__count--hide';
      let $cartWidgetCountNum = $('.cart-widget__count-num');
      let $customerDesire = $('.your-order__list-item--customer-desire');
      let $clearBtn = $('.your-order__order-panel-clear');
      let $nextBtn = $('.your-order__order-panel-block');
      let hideClass = 'your-order__order-panel-content--hide';

      let params = {
        cartId: this.getCartId()
      };

      this.clearCart((res) => {
        if(this.checkProperty(this.checkProperty(res.status) && res.status === 'ok')) {
          this.$nextTick(() => {
            $('.your-order__list-item--product').slideUp(250, function() {
              $(this).remove();
              $customerDesire.slideUp(250, function() {
                $('.your-order__list-item--empty').removeClass('your-order__list-item--hide');
              });

              $cartWidgetCountNum.text(0);
              $cartWidget.removeClass(cartWidgetClass);
              $cartWidgetCount.addClass(cartWidgetCountClass);
              $clearBtn.addClass(hideClass);
              $nextBtn.addClass(hideClass);
            });
          });
        }
      }, params);
    },

    initFancy() {
      $('.your-order__list-item-img-wr-link').fancybox({
        image: {
          preload: true,
        },
        clickContent: function(current, event) {
          return current.type === "image" ? "zoom" : false;
        },
        dblclickContent: false,
        dblclickSlide: false,
        dblclickOutside: false,
        buttons: ['close'],
        infobar: false,
        hash: false
      });
    },

    checkWish() {
      for(let i = 0; i < this.data.order.length - 1; i++) {
        if(this.data.order[i].id == '137') {
          this.wishInCart = true;
          $('.your-order__list-item--wish').find('input').val(this.data.order[i].count);

          if(this.data.order[i].count > 1) {
            $('.your-order__list-item--wish').find('.your-order__list-item-counter-button--dec').removeClass('your-order__list-item-counter-button--disabled');
          }
        }
      }
    }
  }
}
</script>
